import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function InputSelect({label, value, setValue,items,size}) {

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
        size={size || 'medium'}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={handleChange}
        >
            {items?.length > 0 && items?.map((item,i) => (<MenuItem key={i} value={item.IdTipoFallaDec}>{item?.DsTipoFallaDec}</MenuItem>))}
        </Select>
      </FormControl>
    </Box>
  );
}
